import { useCallback } from "react"


export const useTableData = () => {

  const getControlData = useCallback((data, fieldName) => {
    return data[fieldName];
  }, [])


  const loadTableData = useCallback((schema, data) => {

    let tableData = []
    for (let i in schema.properties) {
      let tableRow = {
        "name": i,
        "type": schema.properties[i].type,
        //"analyte": schema.properties[i].prop_analyte,
        //"kv": schema.properties[i].prop_kv,
        //"measure": schema.properties[i].prop_measure,
        "minimum": schema.properties[i].minimum,
        "maximum": schema.properties[i].maximum,
        "decimal_places": schema.properties[i].decimal_places,
        "maxLength": schema.properties[i].maxLength,
        "ais_upload": schema.properties[i].ais_upload,
        "export_rows": schema.properties[i].export_rows,
      }

      //console.log(i)
      //console.log(schema.properties[i])
      tableData.push(tableRow)
    }
    return tableData;
  }, [getControlData])


  const generateSchemafromTable = useCallback((schema, tableData) => {

    // Массив eas_special_rows будет взят из предыдущей schema
    const newSchema = JSON.parse(JSON.stringify(schema));
    delete newSchema.properties;
    newSchema.properties = {};

    console.log('updating schema! New blanc schema:', newSchema)
    console.log('current table data:', tableData)
    //alert(3)

    for (let i in tableData) {
      //console.log(i)
      let props = {
        "type": tableData[i].type,
        "ais_upload": tableData[i].ais_upload,
        "export_rows": tableData[i].export_rows
      }

      if (tableData[i].maximum) {
        if (tableData[i].type === 'integer') {
          props.maximum = parseInt(tableData[i].maximum)
        }
        if (tableData[i].type === 'number') {
          props.maximum = Number(tableData[i].maximum)
        }
      }

      if (tableData[i].minimum) {
        if (tableData[i].type === 'integer') {
          props.minimum = parseInt(tableData[i].minimum)
        }
        if (tableData[i].type === 'number') {
          props.minimum = Number(tableData[i].minimum)
        }
      }      

      if (tableData[i].type === 'number') {
        props.decimal_places = tableData[i].decimal_places
      }

      if (tableData[i].type === 'string') {
        props.maxLength = tableData[i].maxLength
      }

      newSchema.properties[tableData[i].name] = props
    }

    console.log('schema after update:', newSchema)
    //alert(8)

    return newSchema;
  }, [])


  return { 
    loadTableData,
    generateSchemafromTable 
  }

}